import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token if present. localStorage may throw "The operation is
// insecure" in Firefox with strict storage settings — guard defensively.
api.interceptors.request.use((config) => {
  let token = null;
  try { token = localStorage.getItem("tf_admin_token"); } catch { /* storage disabled */ }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const submitInquiry = (payload) => api.post("/inquiries", payload);
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password });
export const adminLogout = () => api.post("/admin/logout");
export const adminChangePassword = (current_password, new_password) =>
  api.post("/admin/change-password", { current_password, new_password });
export const fetchInquiries = () => api.get("/inquiries");
export const fetchStats = () => api.get("/inquiries/stats");
export const updateInquiryStatus = (id, status) =>
  api.patch(`/inquiries/${id}`, { status });
export const deleteInquiry = (id) => api.delete(`/inquiries/${id}`);
export const verifyAdmin = () => api.get("/admin/me");
